import { jsx } from "react/jsx-runtime";
import "react";
import { Text } from "pcln-design-system";
import styled_components from "styled-components";
const StyledPinLabel = /*#__PURE__*/ styled_components(Text).withConfig({
    displayName: "SinglePinLabel__StyledPinLabel"
})([
    "max-width:140px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:box;line-clamp:2;box-orient:vertical;text-shadow:-1px -1px 0 #ffffff,1px -1px 0 #ffffff,-1px 1px 0 #ffffff,1px 1px 0 #ffffff;-webkit-text-stroke:3px #fff;-webkit-text-fill-color:#0068ef;letter-spacing:0.2px;paint-order:stroke fill;"
]);
const SinglePinLabel = (props)=>{
    const { name } = props;
    return /*#__PURE__*/ jsx(StyledPinLabel, {
        bold: true,
        ml: 2,
        color: "primary.base",
        size: 1,
        "data-testid": "single-pin-label",
        children: name
    });
};
export { SinglePinLabel };
